export const SubscriptionProductType = ['spelling', 'number', 'phonics', 'phonics_digital', 'phonics_intervention', 'phonics_supplemental', 'spag', 'litshed', 'freemium'] as const
export type SubscriptionProductType = typeof SubscriptionProductType[number]
